export class IataTerminationResponseModel {
  public Id: number;
  public IdQuestion: number;
  public CheckValue: Boolean;
  public File: string;
  public Approved: boolean;
  public Message: string;
  public CommentsAgency: string;
}
